import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import CommunityCard from './CommunityCard';
import fetchJson from '../fetchJson';

class EmbeddedCommunityCard extends Component {
	constructor(props) {
		super(props);

		this.state = {community: null};
	}

	componentDidMount() {
		fetchJson(`/api/community/?profileUniqueName=${encodeURIComponent(this.props.uniqueName)}`)
			.then(community => this.setState({community}))
			.catch(e => console.error(e));
	}

	render() {
		return this.state.community ? (
			<CommunityCard community={this.state.community} linkToMembers={this.props.linkToMembers} />
		) : null;
	}
}

export default EmbeddedCommunityCard;



// WEBPACK FOOTER //
// ./src/community/EmbeddedCommunityCard.js